import { NgModule  } from '@angular/core';

import { SharedModule }              from '../../app-lite/shared/shared.module';
import { VendorActionsAppComponent } from './vendor.actions.component';

@NgModule({
    declarations: [
        VendorActionsAppComponent
    ],
    entryComponents: [
        VendorActionsAppComponent
    ],
    imports: [
        SharedModule
    ]
})
export class VendorsModule {}